<template>
		<HeaderNavigation />
</template>

<script>
import HeaderNavigation from '@/components/common/HeaderNavigation.vue';

export default {
	components: {
		HeaderNavigation,
	},
};
</script>

<style lang="scss" scoped>
</style>
